import { render, staticRenderFns } from "./FactoryPlace.vue?vue&type=template&id=df006294&"
import script from "./FactoryPlace.vue?vue&type=script&lang=js&"
export * from "./FactoryPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports